import React, { useEffect, useRef, useState } from "react";
import { addBlog, addCourseFees, getColleges, getCourseCategories, getCourses, getUniversities } from "../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../utils/HttpClientXml";
import moment from "moment";
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const AddBlog = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };

  const tabNames = [
  {
    value: "Overview",
    label: "Overview"
  },
  {
    value: "Courses & Fees",
    label: "Courses & Fees"
  },

  {
    value: "Admission",
    label: "Admission"
  },
  {
    value: "Scholarship",
    label: "Scholarship"
  },
  {
    value: "Placements",
    label: "Placements"
  },
  {
    value: "CutOffs",
    label: "CutOffs"
  },
  {
    value: "Ranking",
    label: "Ranking"
  },
  {
    value: "Campus",
    label: "Campus"
  },
  {
    value: "Reviews",
    label: "Reviews"
  },
  {
    value: "Fees",
    label: "Fees"
  }
]

  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false);

  const initialValues = {
    collegeId: "",
    image: "",
    description: "",
    tabName: "",
    date: ""
  }

  const [formData, setFormData] = useState(initialValues)

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res?.data);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchCourseCategories = async () => {
    try {
      setCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async (categoryId) => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data.filter(item => item.categoryId === categoryId));
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, image: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    // if (
    //   !formData?.type ||
    //   !formData?.universityId ||
    //   !formData?.collegeId ||
    //   !formData?.categoryId ||
    //   !formData?.courseDegreeId ||
    //   !formData?.eligibility ||
    //   !formData?.fees ||
    //   !formData?.applicationDate ||
    //   !formData?.courseMode ||
    //   !formData?.brochure
    // ) {
    //   toast.error("Please Enter All Fields");
    //   return;
    // }
    console.log("VFR175", formData);
    // return

    try {
      setCreateLoading(true);
      const res = await addBlog(formData);
      console.log("Blog Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setCreateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Blog.");
      console.error("Error adding Blog:", error);
      setCreateLoading(false);
    }
  };

  useEffect(() => {
    // fetchUniversities()
    fetchColleges()
    // fetchCourseCategories()
  }, [])

  // useEffect(() => {
  //   fetchCourses(formData.categoryId)
  // }, [formData.categoryId])

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Add Blog
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="row d-flex justify-content-center">

                <div
                  className="col-md-6 mt-3"
                >
                  <label htmlFor="name">
                    College Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        collegeId: e?.target?.value,
                      }));
                    }}
                    value={formData?.collegeId}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select College --------
                    </option>
                    {fetchCollegesLoading ? (
                      <option>Loading...</option>
                    ) : colleges?.length === 0 ? (
                      <option>No College Found</option>
                    ) : (
                      colleges.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>


                <div className="col-md-3 mt-3">
                  <label htmlFor="name">
                    Display Tab<span className="text-danger">*</span>
                  </label>
                  <select
                  onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        tabName: e?.target?.value,
                      }));
                    }}
                    value={formData?.tabName}
                    className="form-control"
                  >
                    <option value="">
                      -------- Select Tab --------
                    </option>
                    {
                      tabNames.map((e,key)=>{
                        return <option value={e.value}>{e.label}</option>
                      })
                    }
                  </select>
                </div>

                <div className="col-md-3 mt-3">
                  <label htmlFor="name">
                    Post Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData?.date}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        date: moment(e?.target?.value).format("YYYY-MM-DD"),
                      }));
                    }}
                    placeholder="Applicaion Date"
                    required
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label htmlFor="Brochure">
                    {uploading && "Uploading "} Photo
                  </label>
                  {!uploading && formData?.image && (
                    <>
                      <img
                        src={formData?.image}
                        alt="Photo Preview"
                        style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                      />

                    </>
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="form-control"
                    onChange={handleFileUpload}
                    accept="image/*"
                  />
                </div>


                <div className="col-md-12 mt-3">
                  <label htmlFor="longDescription">
                    Blog/News Description
                  </label>
                  <ReactQuill
                    modules={modules}
                    theme="snow"
                    value={formData?.description}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        description: value,
                      }));
                    }}
                    placeholder="Enter Details"
                    style={{
                      height: "150px",
                      marginBottom: "40px",
                      fontFamily: "Poppins",
                      fontSize: "1rem"
                    }}
                  />
                </div>
              </div>

              <div className=" d-flex justify-content-center">
                <button
                  disabled={createLoading}
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                >
                  {createLoading
                    ? "Saving data..."
                    : "Add Blog"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
